import { Component, computed, Injector, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { takeWhile } from 'rxjs';
import { TextInputComponent } from '../../../../../../../shared/components/forms/text-input/text-input.component';
import { templateDrivenFormsViewProviders } from '../../../../../../../shared/directives/form.directive';
import { QMBlockDirective } from '../../../../../../../shared/directives/quantum-metric.directive';
import { GAService } from '../../../../services/ga-tags.service';
import { OrbitFormClaimService } from '../../../../services/orbit-form-claim.service';
import { getErrorsFromSubmission } from '../../pipes/error-subscription';
import { formValidationGenerator, FormValidators } from '../../pipes/form-validation';

@Component({
  selector: 'app-confirm-your-details',
  imports: [TextInputComponent, FormsModule, QMBlockDirective],
  templateUrl: './confirm-your-details.component.html',
  styleUrl: './confirm-your-details.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
})
export class ConfirmYourDetailsComponent implements OnInit, OnDestroy {
  formValue = input<Record<string, any>>({});
  errors = signal<any>({});
  formValid = output<boolean>();

  private _destroyed = false;

  private viewModel = computed(() => {
    const { bundle } = this.orbitFormClaimService.state.claimData;

    return {
      showMobileSpecificErrors: !!this.errors()?.mobile && !this.errors().section,
      showLandlineSpecificErrors: !!this.errors()?.landline && !this.errors().section,
      mobileError: this.errors()?.mobile || this.errors().section,
      landlineError: this.errors()?.landline || this.errors().section,
      errors: this.errors(),
      formValue: this.formValue(),
      submittingResource: this.orbitFormClaimService.formSubmission,
      address: [
        ...[bundle.addressLine1, bundle.addressLine2, bundle.addressLine3, bundle.addressLine4].map((i) =>
          i.toLowerCase()
        ),
        bundle.postalCode,
      ].filter((v) => !!v && v !== ''),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly injector: Injector,
    private readonly orbitFormClaimService: OrbitFormClaimService,
    private readonly gaService: GAService
  ) {}
  ngOnDestroy(): void {
    this._destroyed = true;
  }

  ngOnInit() {
    this.handleFormValidation();
    this.handleAPIErrors();
    this.trackPageLoad();
  }

  handleFormValidation(): void {
    toObservable(this.formValue, { injector: this.injector })
      .pipe(
        formValidationGenerator(
          {
            email: [FormValidators.required, FormValidators.email],
            mobile: [FormValidators.mobile],
            landline: [FormValidators.landline],
          },
          [
            (val: Record<string, any>) => {
              if (val['mobile'] === '' && val['landline'] === '') {
                return {
                  phone_required: true,
                };
              }
              return null;
            },
          ],
          {
            debounceTimer: 0,
          },
          'confirm-your-details'
        ),
        takeWhile(() => !this._destroyed)
      )
      .subscribe({
        next: ({ isFormValid, errors }) => {
          this.formValid.emit(isFormValid);
          this.errors.set(errors);
        },
      });
  }

  handleAPIErrors(): void {
    getErrorsFromSubmission(this.vm.submittingResource, this.injector, (attempts, error) => {
      console.log({ error });
    });
  }

  trackPageLoad() {
    this.gaService.sendGATag(this.gaService.GA_CONFIRM_YOUR_DETAILS.PAGE_LOAD());
  }
}
